// GENERATED BY process-svg DO NOT EDIT
import { GeneratedIcon } from './Icon'
import { GeneratedIconProps } from './Icon/types'
// @ts-ignore
import Svg from './svg/icon-spotlight.svg?react'

export const IconSpotlight = (props: GeneratedIconProps) => (
  <GeneratedIcon {...props}>
    <Svg preserveAspectRatio="xMidYMid meet" />
  </GeneratedIcon>
)

IconSpotlight.displayName = 'IconSpotlight'
